import React from 'react';
import './popup-lean.scss';

function lean({popupClass, children}) {
    return (
        <div className={`${popupClass}`}>
            {children}
        </div>
    );
}

export default lean;


// WEBPACK FOOTER //
// ./src/fPopup/popup_types/lean/index.js